(function () {
    'use strict';

    let module = angular.module("imApp");

    module.factory("requisitionPlanningService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 778,
                    parameters: parms || {}
                });
            },
            listRequisitionStocks: function (parms) {
                return $ihttp.post({
                    method: 779,
                    parameters: parms || {}
                });
            },
            listRequisitionOrderLines: function (parms) {
                return $ihttp.post({
                    method: 781,
                    parameters: parms || {}
                });
            },
            approvePlan: function (list) {
                return $ihttp.post({
                    method: 785,
                    parameters: list
                });
            }
        };

        return service;
    }]);
})();
